module.exports = "/img/_/_/_/assets/images/creeper/battle/common//21.jpg?1058cf15ec1af9f75c0a430310bfb34d";